export default __webpack_public_path__ + "static/media/040_tunnel.first.1b9d7867.png";